import { render, staticRenderFns } from "./DataSelection.vue?vue&type=template&id=321b5523&scoped=true"
import script from "./DataSelection.vue?vue&type=script&lang=js"
export * from "./DataSelection.vue?vue&type=script&lang=js"
import style0 from "./DataSelection.vue?vue&type=style&index=0&id=321b5523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b5523",
  null
  
)

export default component.exports